import { render } from "./SmallContentItemContainer.vue?vue&type=template&id=727e6f20&scoped=true"
import script from "./SmallContentItemContainer.vue?vue&type=script&lang=js"
export * from "./SmallContentItemContainer.vue?vue&type=script&lang=js"

import "./SmallContentItemContainer.vue?vue&type=style&index=0&id=727e6f20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-727e6f20"]])

export default __exports__